import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  INCOME_VERIFICATION_PROVIDER_CLOSING_DOCS,
} from 'common/incomeVerificationConstants';

import {
  SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
} from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import withLocationQuery from 'client/helpers/withLocationQuery';
import branch from 'client/core/branch';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

@withLocationQuery
@branch()
class SrClosingDocsProofOfConceptPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Closing Docs POC | Sunroom Rentals',
  })

  static propTypes = {
    locationQuery: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      closingDocsIframeUrl: null,
    };
  }

  _onStartIncomeVerificationClick = async () => {
    const { locationQuery, dispatch } = this.props;
    const incomeVerificationUserId = parseInt(locationQuery.userId || 1821, 10);
    const incomeVerificationListingId = parseInt(locationQuery.listingId || 431123, 10);

    const incomeVerificationGroup = await dispatch(postWithState, {
      action: SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
      payload: {
        userIds: [incomeVerificationUserId],
        listingId: incomeVerificationListingId,
        provider: INCOME_VERIFICATION_PROVIDER_CLOSING_DOCS,
      },
    });

    const incomeVerification = incomeVerificationGroup.incomeVerifications.find(({ userId }) => {
      return userId === incomeVerificationUserId;
    });

    this.setState({
      closingDocsIframeUrl: incomeVerification?.screeningUrl,
    });
  }

  _onCloseIncomeVerificationModal = () => {
    this.setState({
      closingDocsIframeUrl: null,
    });
  }

  render() {
    const {
      closingDocsIframeUrl,
    } = this.state;

    return (
      <div>
        {closingDocsIframeUrl &&
          <SrBox position='relative'>
            <SrBox position='absolute' top='100px' left='100px'>
              <SrButton
                theme={SR_BUTTON_THEME_ADOBE_GREEN}
                onClick={this._onCloseIncomeVerificationModal}
              >
                Close
              </SrButton>
            </SrBox>
            <SrBox>
              <iframe
                title='Closing Docs'
                src={closingDocsIframeUrl}
                style={{
                  width: '1400px',
                  height: '1400px',
                }}

              />
            </SrBox>
          </SrBox>
        }

        {!closingDocsIframeUrl &&
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            onClick={this._onStartIncomeVerificationClick}
          >
            Start Income Verification
          </SrButton>
        }
      </div>
    );
  }
}

SrClosingDocsProofOfConceptPage.displayName = 'SrClosingDocsProofOfConceptPage';

export default SrClosingDocsProofOfConceptPage;
